import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IValidateExternalAccountSecuritiesRequest } from '@irb/irb-clients/irb-clients.model';

@Injectable({
  providedIn: 'root'
})
export class IrbClientsService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    })
  };

  constructor(private _http: HttpClient) { }

  importCashSettings(formData: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/import-account-cash-settings", formData, { responseType: 'text' as 'json' });
  }

  importPortfolioNames(formData: any): Observable<Object> {
    return this._http.post("/irebalone/portfolios/import-portfolio-name", formData, { responseType: 'text' as 'json' });
  }

  importPortfolioNamesStatus(importStatusId: string): Observable<Object> {
    if (!/^[0-9]+$/.test(importStatusId)) {
      throw new Error("Invalid character payload.");
    } else {
      const e = encodeURIComponent(importStatusId);
      const u = "/irebalone/portfolios/import-portfolio-names-status/*".replace("*",e);
      return this._http.get(u); 
    }  
  }

  updateImportPortfolioName(data: any): Observable<Object> {
    return this._http.post("/irebalone/portfolios/update-import-portfolio-name", data, this.httpOptions);
  }

  updateImportPortfolioNamesStatus(updateStatusId: string): Observable<Object> {
    return this._http.get("/irebalone/portfolios/update-import-portfolio-name-status/" + encodeURIComponent(updateStatusId));
  }

  importExternalAccounts(formData: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/import-external-accounts", formData, { responseType: 'text' as 'json' });
  }

  importExternalAccountsAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/async/import-external-accounts", formData);
  }

  importExternalAccountsStatus(importStatusId: string): Observable<Object> {
    return this._http.get("/irebalone/accounts/import-extl-acct-status/" + encodeURIComponent(importStatusId));
  }

  validateExternalAccountSecurities(data: IValidateExternalAccountSecuritiesRequest): Observable<Object> {
    return this._http.post("/irebalone/accounts/validate-external-account-securities", data, this.httpOptions);
  }

  validateExternalAccountSecuritiesAsync(data: IValidateExternalAccountSecuritiesRequest): Observable<Object> {
    return this._http.post("/irebalone/accounts/async/validate-external-account-securities", data, this.httpOptions);
  }

  validateExternalAccountSecuritiesAsyncStatus(statusId: string): Observable<Object> {
    return this._http.get<any>('/irebalone/accounts/validate-ext-acct-sec-status/' + statusId, this.httpOptions);
  }

  insertImportedExternalAccounts(data: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/insert-imp-extl-acct-async", data, this.httpOptions);
  }

  importAccountToPortfolioAssignments(formData: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/import-account-to-portfolio-assignments", formData, { responseType: 'text' as 'json' });
  }
  
  updateImportAccountCashSettings(data: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/update-import-account-cash-settings", data, this.httpOptions);
  }

  getPortDropDown(searchStr: string): Observable<Object> {
    return this._http.get("/irebalone/accounts/port-drop-down/" + encodeURIComponent(searchStr), this.httpOptions);
  }

  validateImportCashSettingsAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/async/validate-import-account-cash-settings", formData);
  }

  actionStatusCheck(actionStatusId: any) {
    return this._http.get('/irebalone/accounts/import-account-cash-validate-status/' + actionStatusId);
  }

  updateImportAccountCashSettingsAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/async/update-import-account-cash-settings", formData);
  }

  asyncStatusCheck(statusId : string): Observable<Object> {
    return this._http.get('/irebalone/accounts/async-status-blob/' + statusId);
  }

  importStatusCheck(statusId: string): Observable<Object> {
    return this._http.get("/irebalone/accounts/assign-accounts-to-own-portfolio-status/" + encodeURIComponent(statusId), this.httpOptions);
  }

  validateImportAccountToPortfolioAssignmentsAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/accounts/async-import-account-to-portfolio-assignments", formData);
  }

  validateImportAccountToPortfolioStatus(statusId: string): Observable<Object> {
    return this._http.get("/irebalone/accounts/async-import-account-to-portfolio-assignments/" + encodeURIComponent(statusId), this.httpOptions);
  }
}
